import clsx from "clsx";
import type { EventType, Person } from "@shared/types";

interface FiltersBarProps {
  people: Person[];
  eventTypes: EventType[];
  selectedPeople: string[];
  selectedTypes: string[];
  onTogglePerson: (id: string) => void;
  onToggleType: (id: string) => void;
  onClear: () => void;
}

export function FiltersBar({
  people,
  eventTypes,
  selectedPeople,
  selectedTypes,
  onTogglePerson,
  onToggleType,
  onClear,
}: FiltersBarProps) {
  const hasFilters = selectedPeople.length > 0 || selectedTypes.length > 0;

  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
      <div className="flex flex-wrap items-center gap-1.5">
        {people.map((person) => {
          const active = selectedPeople.length === 0 || selectedPeople.includes(person.id);
          return (
            <button
              key={person.id}
              onClick={() => onTogglePerson(person.id)}
              className={clsx(
                "flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium transition-all",
                active
                  ? "border-transparent text-white shadow-sm"
                  : "border-line dark:border-line-dark text-muted dark:text-muted-dark opacity-60 hover:opacity-100",
              )}
              style={active ? { backgroundColor: person.color } : undefined}
              aria-pressed={selectedPeople.includes(person.id)}
            >
              <span
                className="h-1.5 w-1.5 rounded-full"
                style={{ backgroundColor: active ? "rgba(255,255,255,0.9)" : person.color }}
              />
              {person.name}
            </button>
          );
        })}
      </div>

      <div className="hidden h-5 w-px bg-line dark:bg-line-dark sm:block" />

      <div className="flex flex-wrap items-center gap-1.5">
        {eventTypes.map((type) => {
          const active = selectedTypes.length === 0 || selectedTypes.includes(type.id);
          return (
            <button
              key={type.id}
              onClick={() => onToggleType(type.id)}
              className={clsx(
                "flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium transition-all",
                active
                  ? "border-line dark:border-line-dark text-ink dark:text-ink-dark"
                  : "border-line dark:border-line-dark text-muted dark:text-muted-dark opacity-50 hover:opacity-100",
              )}
            >
              <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: type.color }} />
              {type.name}
            </button>
          );
        })}
      </div>

      {hasFilters && (
        <button
          onClick={onClear}
          className="text-xs font-medium text-muted dark:text-muted-dark underline-offset-2 hover:underline"
        >
          Clear filters
        </button>
      )}

      <p className="w-full text-[11px] text-muted dark:text-muted-dark">
        Card color shows the event type · dots show who's involved
      </p>
    </div>
  );
}
